export const ANALYTICS_EVENTS = {
    SEARCH_BUTTON_CLICKED: 'search_button_clicked',
    CHAT_BUTTON_CLICKED: 'chat_button_clicked',
    NAVIGATION_MENU_ITEM_CLICKED: 'navigation_menu_item_clicked',
    BACK_BUTTON_CLICKED: 'back_button_clicked',
    USER_FEEDBACK_CLOSED: 'user_feedback_closed',
    PROFILE_DROPDOWN_ADD_INDIVIDUAL_ACCOUNT_CLICKED: 'profile_dropdown_add_individual_account_clicked',
    ADVISER_CLIENTS_ADD_ACCOUNT_CLICKED: 'adviser_clients_add_account_clicked',
    ADVISER_CLIENTS_RESUME_KYC_CLICKED: 'adviser_clients_resume_kyc_clicked',
    ACCOUNT: {
        TFN_SUBMITTED: 'tfn_submitted',
    },
    PWA: {
        INSTALL_APP_CLICKED: 'pwa_install_app_clicked',
        INSTALL_APP_PROMOTIONS_SHOWN: 'pwa_app_promotion_shown',
    },
    AUTH: {
        LOGIN_MFA_VERIFY_SUBMITTED: 'login_mfa_verify_submitted',
        LOGIN_MFA_VERIFY_FAILED: 'login_mfa_verify_failed',
    },
    PASSKEY: {
        SETUP_SUBMITTED: 'setup_passkey_submitted',
        SETUP_FAILED: 'setup_passkey_failed',
        SETUP_SKIPPED: 'setup_passkey_skipped',
        AUTH_SUBMITTED: 'passkey_auth_submitted',
        AUTH_FAILED: 'passkey_auth_failed',
        AUTH_LOGOUT: 'passkey_auth_logout',
    },
    ONBOARDING: {
        VERIFICATION_BACK: 'onboarding_verification_back',
        VERIFICATION_SUCCESS: 'onboarding_verification_success',
        VERIFICATION_FAILED: 'onboarding_verification_failed',
        VERIFICATION_RESENT: 'onboarding_verification_resent',
        VERIFICATION_RESENT_FAILED: 'onboarding_verification_resent_failed',
        ONBOARDING_CLIENT_SUBMITTED: 'onboarding_client_submitted',
        ONBOARDING_ACCOUNT_TYPE_SUBMITTED: 'onboarding_account_type_submitted',
        ONBOARDING_ACCOUNT_TYPE_FAILED: 'onboarding_account_type_failed',
        ONBOARDING_SURVEY_SUBMITTED: 'onboarding_survey_submitted',
        ONBOARD_CLIENT_ACCESS_SUBMITTED: 'onboard_client_access_submitted',
        ONBOARDING_KYC_SKIPPED: 'KYC Skipped',
        ONBOARDING_ADD_BANK_ACCOUNT_SUBMITTED: 'onboarding_add_bank_account_submitted',
        ONBOARDING_BANK_ACCOUNT_ALERT_CLICKED: 'onboarding_bank_account_alert_clicked',
        ONBOARDING_FRANKIE_KYC_INTRO_SUBMITTED: 'onboarding_frankie_kyc_intro_submitted',
        ONBOARDING_KYC_CONSENT_SUBMITTED: 'onboarding_kyc_consent_submitted',
        ONBOARDING_KYC_PERSONAL_SUBMITTED: 'onboarding_kyc_personal_submitted',
        ONBOARDING_KYC_DOCUMENT_SUBMITTED: 'onboarding_kyc_document_submitted',
        ONBOARDING_KYC_REVIEW_SUBMITTED: 'onboarding_kyc_review_submitted',
        ONBOARDING_KYC_RESULT_SUCCESS: 'onboarding_kyc_result_success',
        ONBOARDING_KYC_RESULT_FAILED: 'onboarding_kyc_result_failed',
        ONBOARDING_KYC_RESULT_PENDING: 'onboarding_kyc_result_pending',
        ONBOARDING_ACCOUNT_CONFIRMATION_SUBMITTED: 'onboarding_account_confirmation_submitted',
    },
    TRADING: {
        BUNDLE_SELECTED: 'bundle_selected',
        BUNDLE_TRADE_STARTED: 'bundle_buy_order_started',
        BUNDLE_TRADE_REVIEWED: 'bundle_buy_order_reviewed',
        BUNDLE_TRADE_SUBMITTED: 'bundle_buy_order_submitted',
        BUNDLE_SECURITY_CLICKED: 'bundle_security_clicked',
        TRENDING_ETF_SECURITY_CLICKED: 'trending_etf_security_clicked',
        TRADING_PAGE_SECURITY_CARD_CLICKED: 'TradingPageSecurityCard Clicked',
        BUNDLE_INVESTMENT_AMOUNT_CHANGED: 'bundle_investment_amount_changed',
        BUNDLE_SECURITIES_AMOUNT_CHANGED: 'bundle_securities_amount_changed',
        BUNDLE_SECURITIES_UNITS_CHANGED: 'bundle_securities_units_changed',
        BUNDLE_SECURITIES_MINIMUM_CLICKED: 'bundle_securities_minimum_clicked',
        BUNDLE_SECURITIES_LIMIT_PRICE_CHANGED: 'bundle_securities_limit_price_changed',
        BUNDLE_TRADE_RESET: 'bundle_buy_order_reset',
        BUNDLE_ABOUT_READ_MORE_CLICKED: 'bundle_read_more_clicked',
        BUNDLE_CHART_RANGE_CLICKED: 'bundle_chart_range_clicked',
        BUNDLE_TOOLTIP_OPENED: 'bundle_tooltip_opened',

        BUY_ORDER_STARTED: 'BuyOrder Started',
        BUY_ORDER_REVIEWED: 'BuyOrder Reviewed',
        BUY_ORDER_SUBMITTED: 'BuyOrder Submitted',
        SELL_ORDER_SUBMITTED: 'SellOrder Submitted',
        BUY_ORDER_FAILED: 'buy_order_failed',
    },
    FIND_STOCKS: {
        ETF_CARD_SELECTED: 'etf_card_selected',
        STOCK_TYPE_SELECTED: 'stock_type_selected',
        ETHICAL_FILTER_SELECTED: 'ethical_filter_selected',
    },
    WALLET: {
        ADD_FUNDS_BUTTON_CLICKED: 'add_funds_button_clicked',
        PAY_ID_ADDRESS_COPIED: 'PayIdAddress Copied',
    },
    INSTRUMENT_SEARCH: {
        SEARCH_PERFORMED: 'InstrumentSearch searched',
        RESULT_CLICKED: 'InstrumentSearchResultItem clicked',
    },
    PORTFOLIO: {
        PORTFOLIO_STOCK_CLICKED: 'portfolio_stock_clicked',
        PORTFOLIO_VIEW_CLICKED: 'portfolio_view_clicked',
    },
    CAMPAIGNS: {
        CAMPAIGN_CLICKED: 'campaign_clicked',
        CAMPAIGN_BUY_BUTTON_CLICKED: 'campaign_buy_button_clicked',
    },
    BLOGS: {
        BLOG_CLICKED: 'blog_clicked',
        BLOG_FILTER_APPLIED: 'blog_filter_applied',
    },
} as const
